import axios from "axios";

export const deleteSurvey = async (id, data) => {
    try {
      const res = await axios.patch(`/api/Company/updateCampaign?campaignId=${id}`, data);
      return res;
    } catch (error) {
      console.log(error.message);
    }
  };

export const getPrioritySurvey = async (panelId) => {
    try {
      const res = await axios.get(`/api/company/getPrioritySurvey?panelId=${panelId}`);
      return res;
    } catch (error) {
      console.log(error.message);
    }
  };

export const updatePriority = async (surveyId, isPriority) => {
    try {
      const res = await axios.post(`/api/company/updatePriority?clientApiSurveyId=${surveyId}&isPriority=${isPriority}`);
      return res;
    } catch (error) {
      console.log(error.message);
    }
  };


